import HeaderContainer from '@/src/components/common/header/HeaderRouter'
import SrpErrorStateWrapper from '@/src/components/common/srp/errorState'
import FiltersWrapper from '@/src/components/common/srp/filters'
import Statusbar from '@/src/components/common/ui/statusbar'
import FareFamilyWrapper from '@/src/components/desktop/srp/fareFamily'
import FlightResultsWrapper from '@/src/components/desktop/srp/flightResults'
import FlightDetailsWrapperDesktop from '@/src/components/desktop/srp/flightResults/flightDetails'
import FlightDetailsSlider from '@/src/components/desktop/srp/flightResults/flightDetails/flightDetails'
import FlightScheduleBreadcrumbs from '@/src/components/desktop/srp/flightSchedule/breadcrumbs'
import Faq from '@/src/components/desktop/srp/flightSchedule/faq'
import SEOFilterWrapper from '@/src/components/desktop/srp/flightSchedule/filter'
import FlightScheduleFooter from '@/src/components/desktop/srp/flightSchedule/footer'
import Heading from '@/src/components/desktop/srp/flightSchedule/heading'
import Links from '@/src/components/desktop/srp/flightSchedule/links'
import SearchHeader from '@/src/components/desktop/srp/searchHeader'
import { DESKTOP } from '@/src/constants/deviceTypes'
import { useSrpContext } from '@/src/contexts'
import useSrpController from '@/src/hooks/srp/srpController'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { Backdrop, Box, Container, Dialog, Divider } from '@mui/material'
import { useState } from 'react'
import StickyBox from 'react-sticky-box'
import ErrorBoundaryWrapper from '../../common/ErrorBoundary'
import FlightSchedulePage from './flightSchedule'

const FlightSchedulePageDesktopContainer = ({ domainCountry }: { domainCountry: string }) => {
    const {
        srpResultsLoading: isClientLoading,
        srpResultsError,
        showEmptyFlightScreen,
        invalidUrl,
        jsons,
        sectors,
        sid
    } = useSearchResults()
    const {
        onViewFlightDetails,
        handleBookClick,
        isBookingInProgress,
        loadingFlightKey,
        selectedFlightForFlightDetails,
        handleFlightDetailsClose,
        selectedFlightForFareFamily,
        setSelectedFlightForFareFamily,
        handleCreateBooking,
        rawFareFamilyData,
        setRawFareFamilyData
    } = useSrpController({
        deviceType: 'DESKTOP'
    })
    const isClientError = !!srpResultsError || invalidUrl
    const [menuOpen, setMenuOpen] = useState(false)
    const [showLimitedView, setShowLimitedView] = useState(true)
    const handleOverlayOpen = () => setMenuOpen(true)
    const handleOverlayClose = () => setMenuOpen(false)
    const {
        SEOSrpData: { pageData }
    } = useSrpContext()
    const pageContent = pageData?.pageContent?.content
    const handleLoadMore = () => {
        setShowLimitedView(false)
    }

    // const isClientLoading = true
    return (
        <>
            <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', position: 'relative' }}>
                <ErrorBoundaryWrapper identifier="HeaderContainer-desktop-srp">
                    <HeaderContainer domainCountry={domainCountry} />
                </ErrorBoundaryWrapper>
                <ErrorBoundaryWrapper identifier="Statusbar-desktop-srp">
                    <Statusbar loading={isClientLoading} />
                </ErrorBoundaryWrapper>
                <Backdrop
                    open={menuOpen}
                    onClick={handleOverlayClose}
                    sx={{
                        zIndex: 1300,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)'
                    }}
                />

                <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, lg: 4 }, py: 1 }}>
                    {invalidUrl !== 'dateInPast' && (
                        <Box
                            sx={theme => ({
                                width: {
                                    xs: `calc(100% + ${theme.spacing(3)})`,
                                    lg: `calc(100% + ${theme.spacing(4)})`
                                },
                                position: 'relative',
                                zIndex: menuOpen ? 1400 : 1,
                                pb: 1
                            })}
                        >
                            <ErrorBoundaryWrapper identifier="searchHeader-desktop-srp">
                                <SearchHeader
                                    jsons={jsons}
                                    overlayOpen={handleOverlayOpen}
                                    overlayClose={handleOverlayClose}
                                    srpResultsLoading={isClientLoading}
                                />
                            </ErrorBoundaryWrapper>
                        </Box>
                    )}

                    {isClientError ? (
                        <ErrorBoundaryWrapper identifier="SrpErrorStateWrapper-desktop-srp">
                            <SrpErrorStateWrapper
                                pastDateError={invalidUrl === 'dateInPast'}
                                errorStatus={
                                    invalidUrl === 'requiredFieldsMissing' ? 400 : srpResultsError?.status || 500
                                }
                            />
                        </ErrorBoundaryWrapper>
                    ) : (
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '280px 1fr',
                                gap: { xs: 3, lg: 4 },
                                alignItems: 'start'
                            }}
                        >
                            <StickyBox offsetTop={24} offsetBottom={24}>
                                <ErrorBoundaryWrapper identifier="sideBar-filters-wrapper-desktop-srp">
                                    {isClientLoading ? (
                                        <SEOFilterWrapper />
                                    ) : (
                                        <>{!isClientError && <FiltersWrapper deviceType={DESKTOP} />}</>
                                    )}
                                </ErrorBoundaryWrapper>
                            </StickyBox>

                            <Box sx={{ order: { xs: 1, lg: 2 } }}>
                                <FlightScheduleBreadcrumbs />
                                <Heading />
                                <ErrorBoundaryWrapper identifier="FlightResultsWrapper-desktop-srp">
                                    {isClientLoading ? (
                                        <FlightSchedulePage />
                                    ) : (
                                        <FlightResultsWrapper
                                            onBookFlight={handleBookClick}
                                            onSortByPrice={() => { }}
                                            onViewDetails={flight => onViewFlightDetails([flight])}
                                            isBookingInProgress={isBookingInProgress}
                                            loadingFlightKey={loadingFlightKey}
                                            limitedView={showLimitedView}
                                            limitedCount={5}
                                            showLoadMore={showLimitedView}
                                            onLoadMore={handleLoadMore}
                                        />
                                    )}
                                </ErrorBoundaryWrapper>
                                {pageContent && <Box component={"section"} dangerouslySetInnerHTML={{
                                    __html: pageContent
                                }}>

                                </Box>}
                                <Faq />
                            </Box>
                        </Box>
                    )}
                </Container>
                <Divider />
                <Links />
                <FlightScheduleFooter />
            </Box>

            <FlightDetailsWrapperDesktop open={!!selectedFlightForFlightDetails} onClose={handleFlightDetailsClose}>
                {!!selectedFlightForFlightDetails ? (
                    <FlightDetailsSlider
                        onClose={handleFlightDetailsClose}
                        flights={selectedFlightForFlightDetails}
                        jsons={jsons!}
                        sectors={sectors!}
                        onSelect={() => handleBookClick(selectedFlightForFlightDetails[0])}
                        sid={sid!}
                        showBaggage={true}
                        isRTSolutionView={false}
                        isBookingInProgress={isBookingInProgress}
                    />
                ) : null}
            </FlightDetailsWrapperDesktop>

            <Dialog
                dir={(typeof window !== 'undefined' && window.location.pathname.split('/')[1]) === 'ar' ? 'rtl' : 'ltr'}
                open={!!selectedFlightForFareFamily}
                onClose={() => setSelectedFlightForFareFamily(null)}
                maxWidth="xl"
                fullWidth
                slotProps={{
                    paper: { sx: { maxWidth: '80rem', margin: 0, minWidth: 'min(100%,1024px)' } },
                    backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.7)' } }
                }}
            >
                {selectedFlightForFareFamily && (
                    <FareFamilyWrapper
                        flight={selectedFlightForFareFamily}
                        sectors={sectors!}
                        handleClose={() => {
                            setSelectedFlightForFareFamily(null)
                            setRawFareFamilyData(null)
                        }}
                        handleCreateBooking={(flight, fareFamilyData) => handleCreateBooking([flight], [fareFamilyData])}
                        jsons={jsons!}
                        desktop={true}
                        rawFareFamilyData={rawFareFamilyData ? rawFareFamilyData : undefined}
                    />
                )}
            </Dialog>
        </>
    )
}

export default FlightSchedulePageDesktopContainer
